import { cn } from "@/lib/utils";

const MAP = {
  draft: "bg-zinc-100 text-zinc-700",
  submitted: "bg-sky-100 text-sky-800",
  awaiting: "bg-sky-100 text-sky-800",
  approved: "bg-emerald-100 text-emerald-800",
  returned: "bg-amber-100 text-amber-800",
  rejected: "bg-rose-100 text-rose-800",
  locked: "bg-slate-800 text-white",
  exported: "bg-indigo-100 text-indigo-800",
  pending: "bg-amber-100 text-amber-800",
  cancelled: "bg-zinc-100 text-zinc-500",
  active: "bg-emerald-100 text-emerald-800",
  on_hold: "bg-amber-100 text-amber-800",
  completed: "bg-indigo-100 text-indigo-800",
  archived: "bg-zinc-100 text-zinc-500",
  not_started: "bg-zinc-100 text-zinc-500",
};

export function StatusBadge({ status, className }) {
  const key = String(status || "").toLowerCase();
  return (
    <span
      data-testid={`status-${key}`}
      className={cn(
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold uppercase tracking-wider",
        MAP[key] || "bg-zinc-100 text-zinc-700",
        className
      )}
    >
      {String(status || "—").replace(/_/g, " ")}
    </span>
  );
}
